import React, { useRef, useState } from "react";

import { getImageUrl } from "utils/helpers";
import styled from "styled-components";
import theme from "styles/theme";

const SvgImageContainer = styled.div`
  visibility: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};

  max-height: ${(props) => props.$height || 48}px;
  width: calc(
    ${(props) => props.$height || 48}px *
      ${({ $svgAspectRatio }) => $svgAspectRatio}
  );

  ${theme.media.phone`
    max-height: ${(props) => props.$mobileHeight || 32}px;
    width: calc(${(props) => props.$mobileHeight || 32}px * ${({
    $svgAspectRatio,
  }) => $svgAspectRatio});
  `}
`;

const SvgImage = styled.img`
  width: 100%;
  height: 100%;
`;

const NonSvgImage = styled.img`
  max-height: ${(props) => props.$height || 48}px;

  ${theme.media.phone`
    max-height: ${(props) => props.$mobileHeight || 32}px;
  `}
`;

const CompanyLogo = ({
  className,
  logoUrl,
  employerProfile,
  shouldIgnoreCareerPageUrl,
  alt,
  height,
  mobileHeight,
}) => {
  const [svgAspectRatio, setSvgAspectRatio] = useState(0);

  const svgRef = useRef(null);

  const getSvgAspectRatio = () => {
    if (!svgRef.current) return;

    const svgImg = svgRef.current;
    const aspectRatio = svgImg.naturalWidth / svgImg.naturalHeight;

    // console.log(aspectRatio);

    setSvgAspectRatio(aspectRatio);
  };

  let companyUrl = null;
  if (employerProfile) {
    if (shouldIgnoreCareerPageUrl) {
      companyUrl = employerProfile.website || employerProfile.emailDomain;
    } else {
      companyUrl =
        employerProfile.careerPageUrl ||
        employerProfile.website ||
        employerProfile.emailDomain;
    }
    if (companyUrl && !companyUrl.startsWith("http")) {
      companyUrl = `https://${companyUrl}`;
    }
  }

  if (logoUrl.endsWith(".svg")) {
    return (
      <a href={companyUrl}>
        <SvgImageContainer
          $svgAspectRatio={svgAspectRatio}
          $isVisible={svgAspectRatio}
          $height={height}
          $mobileHeight={mobileHeight}
        >
          <SvgImage
            className={className}
            ref={svgRef}
            src={logoUrl}
            alt={alt}
            onLoad={getSvgAspectRatio}
          />
        </SvgImageContainer>
      </a>
    );
  }

  return (
    <a href={companyUrl}>
      <NonSvgImage
        className={className}
        src={getImageUrl(logoUrl, "png", 300)}
        alt={alt}
        $height={height}
        $mobileHeight={mobileHeight}
      />
    </a>
  );
};

export default CompanyLogo;
